import { memo, useEffect, useRef } from 'react'
import { FormSpy } from 'react-final-form'
import useDeepCompareEffect from 'hooks/useDeepCompareEffect'

export type StepFields = {
  step: string
  fields: string[]
}[]

const NavigateOnError = memo(
  ({
    setStep,
    errors,
    stepFields
  }: {
    setStep: (step: string) => void
    errors: string[]
    stepFields: StepFields
  }) => {
    const setStepRef = useRef(setStep)
    useEffect(() => {
      setStepRef.current = setStep
    }, [setStep])
    useDeepCompareEffect(() => {
      const stepsWithErrors = stepFields.filter((stepWithField) => {
        for (const e of errors) {
          if (stepWithField.fields.includes(e)) {
            return true
          }
        }
        return false
      })
      if (stepsWithErrors.length > 0) {
        setStepRef.current(stepsWithErrors[0].step)
      }
    }, [errors, stepFields])
    return null
  }
)

NavigateOnError.displayName = 'NavigateOnError'

const NavigateToErrorStep = ({
  setStep,
  stepFields
}: {
  setStep: (step: string) => void
  stepFields: StepFields
}) => {
  return (
    <FormSpy subscription={{ errors: true, submitErrors: true }}>
      {({ errors, submitErrors }) => {
        const allErrors = [
          ...Object.keys(errors ?? {}),
          ...Object.keys(submitErrors ?? {})
        ]

        return (
          <NavigateOnError
            errors={allErrors}
            setStep={setStep}
            stepFields={stepFields}
          />
        )
      }}
    </FormSpy>
  )
}

export default NavigateToErrorStep
